import { ProfitRow } from '../../../models/profit/profit.model';
import { useGet } from '../../useApi';

// GET /admin/profit/overview: today's and this month's profit and its parts.
const useProfitOverview = () => {
  const { data, loading, fetch } = useGet<{ today: ProfitRow; month: ProfitRow }>('Failed to load profit');
  return { overview: data, loading, fetchOverview: () => fetch('api/v1/admin/profit/overview') };
};

export default useProfitOverview;
